// 副資材まわりの projection ロジック呼び出し口をまとめます。
// 実装本体は当面 Kakousiji.js に残し、呼び出し経路だけをここへ集約します。
export function createFukushizaiProjection(deps) {
    return {
        // BASE 項目変更を detail へ反映します。
        syncBaseFieldValueToDetail(fieldId, value) {
            return deps.syncFukushizaiBaseFieldValueToDetail(fieldId, value);
        },
        // 表示用 Grid 行を detail へ戻します。
        syncDisplayRowsToDetail(panelInfo, rows, options) {
            return deps.syncFukushizaiDisplayRowsToDetail(panelInfo, rows, options);
        },
        // 表示用 Grid へ確定済み行を即時再反映します。
        applyDisplayRowsNow(panelInfo, rows) {
            return deps.applyFukushizaiDisplayRowsNow(panelInfo, rows);
        },
        // 現在の item/group/context に対応する表示セクション群を更新します。
        refreshSectionViews(itemCd, groupNo, previewOverride, contextOverride) {
            return deps.refreshFukushizaiSectionViews(itemCd, groupNo, previewOverride, contextOverride);
        }
    };
}
